module.exports = __webpack_public_path__ + "edc610c92d577dd21c13ce0ded3d2347.svg";